import React, { Component } from "react";
import { connect } from "react-redux";
import Header from "../Header/header";
import Footer from "../Footer/footer";
import HeaderContainer from "../Header/LandingHeader/HeaderContainer"
import SettingsProfile from "./settingsprofile";
import SettingsSubscription from './settingsSubscription'
import {
  Layoutstyled,
  Contentstyled,
  ColShadow,
  SpanBlue
} from "../Constants/style";
import {  Menu, Row } from "antd";

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayModifProfile: "",
      displayModifAbo: "none",
      displayHisto: "none",
      displayFacture: "none",
      displayRemuneration: "none" //si pro
    };
  }

  handleDisplayNav = e => {
    if (e.key === "0") {
      this.setState({
        displayModifProfile: "",
        displayModifAbo: "none",
        displayHisto: "none",
        displayFacture: "none",
        displayRemuneration: "none"
      });
    } else if (e.key === "1") {
      this.setState({
        displayModifProfile: "none",
        displayModifAbo: "",
        displayHisto: "none",
        displayFacture: "none",
        displayRemuneration: "none"
      });
    } else if (e.key === "2") {
      this.setState({
        displayModifProfile: "none",
        displayModifAbo: "none",
        displayHisto: "",
        displayFacture: "none",
        displayRemuneration: "none"
      });
    } else if (e.key === "3") {
      this.setState({
        displayModifProfile: "none",
        displayModifAbo: "none",
        displayHisto: "none",
        displayFacture: "",
        displayRemuneration: "none"
      });
    } else if (e.key === "4") {
      this.setState({
        displayModifProfile: "none",
        displayModifAbo: "none",
        displayHisto: "none",
        displayFacture: "none",
        displayRemuneration: ""
      });
    }
  };
  /*
  <Menu
    style={{ border: "none" }}
    defaultOpenKeys={["sub1"]}
    mode="vertical"
    onClick={this.handleDisplayNav}
  >
    <Menu.Item key="0">
      <SpanBlue>Modifier mon profil</SpanBlue>
    </Menu.Item>
    <Menu.Item key="1">
      <SpanBlue>{`Mon abonnement`}</SpanBlue>
    </Menu.Item>
    <Menu.Item key="2">
      <SpanBlue>{`Mon historique`}</SpanBlue>
    </Menu.Item>
    <Menu.Item key="3">
      <SpanBlue>{`Facture`}</SpanBlue>
    </Menu.Item>
    <Menu.Item key="4">
      <SpanBlue>{`Rémunération`}</SpanBlue>
    </Menu.Item>
  </Menu>
  */

  render() {
    return (
      <Layoutstyled>
        <Header />
        <HeaderContainer />
        <Contentstyled>
          <Row type="flex">
            <ColShadow
              style={{
                background: "#fff",
                padding: 24,
                radius: 4
              }}
              xs={24}
              lg={6}
              xl={5}
            >
              <Menu
                style={{ border: "none" }}
                defaultOpenKeys={["sub1"]}
                mode="vertical"
                onClick={this.handleDisplayNav}
              >
                <Menu.Item key="0">
                  <SpanBlue>Modifier mon profil</SpanBlue>
                </Menu.Item>
              </Menu>
            </ColShadow>
            <ColShadow
              style={{ background: "#fff", padding: 24, radius: 10 }}
              xs={24}
              lg={{ span: 17, offset: 1 }}
              xl={{ span: 17, offset: 1 }}
            >
              <div style={{ display: this.state.displayModifProfile }}>
                <SettingsProfile />
              </div>
              <div style={{ display: this.state.displayModifAbo }}>
                <SettingsSubscription />
              </div>
              <div style={{ display: this.state.displayHisto }}>historique</div>
              <div style={{ display: this.state.displayFacture }}>factu$</div>
              <div style={{ display: this.state.displayRemuneration }}>
                reémun
              </div>
            </ColShadow>
          </Row>
        </Contentstyled>
        <Footer />
      </Layoutstyled>
    );
  }
}

const mapStateToProps = globalReducers => globalReducers;
const connectedSettings = connect(
  mapStateToProps,
  null
)(Settings);
export default connectedSettings;
